import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParametersDataState } from './parameters-data.reducer';
import { ParameterData } from 'src/app/pages/admin-manager/parameters/models/parameters.model';

export const selectParametersDataState = createFeatureSelector<ParametersDataState>('parametersData');

export const selectParametersDataResponse = createSelector(selectParametersDataState, (state) => state.response);

export const selectParametersDataLoading = createSelector(selectParametersDataState, (state) => state.loading);

export const selectParametersDataError = createSelector(selectParametersDataState, (state) => state.error);

export const selectParametersDataByKey = (key: string) =>
  createSelector(selectParametersDataState, (state) => (state.cache || {})[key] ?? null);

export const selectParametersDataHasDataByKey = (key: string) =>
  createSelector(selectParametersDataState, (state) => !!(state.cache || {})[key]);

export const selectParametersDataLoadingByKey = (key: string) =>
  createSelector(selectParametersDataState, (state) => !!(state.loadingByKey || {})[key]);

export const selectParametersDataErrorByKey = (key: string) =>
  createSelector(selectParametersDataState, (state) => (state.errorByKey || {})[key] ?? null);

export const selectParametersDataCache = createSelector(
  selectParametersDataState,
  (state): Record<string, ParameterData> => state.cache || {},
);

export const selectAllParametersData = createSelector(selectParametersDataCache, (cache): ParameterData[] =>
  Object.values(cache || {}),
);
